export enum ExceptionEnum {
  network_disconnected,
  // file_not_found,
  // folder_not_found,
  //
  // upload_error,
  //
  // download_error,
  //
  // oss_error,

  /* http status 401  */
  sc_unauthorized = 401,

  /* http status 403，服务器拒绝请求  */
  forbidden_error = 403,

  /* http status 404，服务器找不到请求的网页  */
  notfind_error = 404,

  /* http status 408，服务器等候请求时发生超时  */
  timeout_error = 408,

  /* http status 499，业务错误  */
  biz_error = 499,

  /* http status 498，参数验证错误  */
  verify_error = 498,

  /* 未定义异常*/
  undefined_error,

  /*自定义异常*/
  custom_error,

  /* http status 500，服务器异常 */
  server_error = 500,

  /* http status 502，错误网关 */
  bad_gateway = 502,

  /* http status 503，服务不可用  */
  unavailable_error = 503,

  /* http status 504，网关超时  */
  network_timeout = 504
}
